import { render, staticRenderFns } from "./Crumbs.vue?vue&type=template&id=93df5b36&"
import script from "./Crumbs.vue?vue&type=script&lang=js&"
export * from "./Crumbs.vue?vue&type=script&lang=js&"
import style0 from "./Crumbs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports